import { defineStyleConfig } from '@chakra-ui/react';

export const textSizes = {
  headingHero: {
    fontSize: ['24px', '36px'],
    fontWeight: 600,
    lineHeight: ['28px', '40px'],
    letterSpacing: 0,
  },
  headingPrimary: {
    fontSize: ['20px', '24px'],
    fontWeight: 600,
    lineHeight: ['24px', '32px'],
    letterSpacing: 0,
  },
  headingSecondary: {
    fontSize: ['18px', '20px'],
    fontWeight: 600,
    lineHeight: ['20px', '28px'],
    letterSpacing: 0,
  },
  heroRegular: {
    fontSize: ['14px', '18px'],
    fontWeight: 400,
    lineHeight: ['20px', '24px'],
    letterSpacing: 0,
  },
  heroSemiBold: {
    fontSize: ['14px', '18px'],
    fontWeight: 600,
    lineHeight: ['20px', '24px'],
    letterSpacing: 0,
  },
  primaryRegular: {
    fontSize: ['14px', '16px'],
    fontWeight: 400,
    lineHeight: ['20px', '20px'],
    letterSpacing: 0,
  },
  primarySemiBold: {
    fontSize: ['14px', '16px'],
    fontWeight: 600,
    lineHeight: ['20px', '20px'],
    letterSpacing: 0,
  },
  secondaryRegular: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: 0,
  },
  secondarySemiBold: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: 0,
  },
  notePrimaryRegular: {
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: 0,
  },
  notePrimarySemiBold: {
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: 0,
  },
  tagPrimary: {
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: 0,
    textTransform: 'uppercase',
  },
  additionalRegular: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: 0,
  },
  subAdditionalRegular: {
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '12px',
    letterSpacing: 0,
  },
};

export const textTheme = defineStyleConfig({
  baseStyle: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    letterSpacing: 0,
  },
  sizes: textSizes,
});
